import { printf, toText, isNullOrWhiteSpace } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { Msg, Page } from "./Types.fs.js";
import * as react from "react";
import { DOMAttr, HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { Video_Quickfinder } from "../../../Kundenportal.Types.fs.js";
import { GlobalMessageBox_InfoWithTitle, GlobalMsg } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { errorMsg, spinner, Icons_TicketErstellenLink, Icons_TicketLink, nothing, Icons_DownloadLink2, Icons_DownloadLink, linkicon } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { asMonatJahr, asLongString, asString } from "../../../../Bfs.Web.Data.Service.Contracts/Shared.fs.js";
import { Http_downloadUrlSammelrechnung, Http_downloadUrlDokumentAnfrage } from "./State.fs.js";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../../../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { value as value_1 } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { defaultOf, int32ToString } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { toArray, empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { Page as Page_1 } from "../Tickets/Types.fs.js";
import { Quickfinder_Information_get_NoInformation, Quickfinder_QuickFinderIcon__ToCssIcon } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { CollapsableElement } from "../../../../Bfs.Web.Portale/Collapsable.fs.js";
import { year, month } from "../../../fable_modules/fable-library-js.4.19.0/Date.js";
import { isEmpty, length, map as map_1, toArray as toArray_1, reverse } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { append as append_1, pairwise, map, concat } from "../../../fable_modules/fable-library-js.4.19.0/Array.js";
import { asMoneySpan } from "../../../../Bfs.Web.Portale/Helpers.fs.js";

export function onRechnungsnummerEnter(navigateTo) {
    const nummer = document.getElementById("quickfinder-rechnungsnummer").value;
    if (!isNullOrWhiteSpace(nummer)) {
        navigateTo(new Page(0, [nummer]));
    }
}

export function quickfinderBox(navigateTo, globalMsgdispatch, nummer) {
    let children_30, children_28, children_26, children_24, children_12, children_10, children_2, props_12, children_8, props_10, children_6, children_22, children_20, children_14, children_18;
    const children_32 = [(children_30 = [(children_28 = [(children_26 = [(children_24 = [(children_12 = [react.createElement("img", {
        className: "quickfinderImg is-hidden-touch",
        src: "quickfinder/bfs_quickfinder_1.png",
    }), react.createElement("img", {
        className: "quickfinderImgSmall is-hidden-desktop",
        src: "quickfinder/bfs_quickfinder_1.png",
    }), (children_10 = [(children_2 = [react.createElement("b", {}, "Das Wichtigste auf einen Klick!")], react.createElement("p", {}, ...children_2)), react.createElement("p", {
        className: "sub",
    }, "Hier finden Sie schnell Informationen zu einer beliebigen Rechnung."), (props_12 = [new HTMLAttr(65, ["sub"]), ["style", {
        marginTop: "8px",
    }]], (children_8 = [(props_10 = [new DOMAttr(40, [(_arg) => {
        globalMsgdispatch(new GlobalMsg(5, [Video_Quickfinder]));
    }]), ["style", {
        marginLeft: -10,
    }]], (children_6 = [linkicon("fas fa-play-circle"), "Video zum Quick Finder anschauen"], react.createElement("a", keyValueList(props_10, 1), ...children_6)))], react.createElement("p", keyValueList(props_12, 1), ...children_8)))], react.createElement("div", {}, ...children_10))], react.createElement("div", {
        className: "column is-8-fullhd is-8-widescreen is-8-desktop is-6-tablet is-12-mobile firstcol",
    }, ...children_12)), (children_22 = [(children_20 = [(children_14 = [react.createElement("input", {
        id: "quickfinder-rechnungsnummer",
        className: "input",
        type: "text",
        defaultValue: nummer,
        onKeyDown: (e) => {
            if (e.key === "Enter") {
                onRechnungsnummerEnter(navigateTo);
            }
        },
        placeholder: "Rechnungsnr.",
    })], react.createElement("div", {
        className: "control",
    }, ...children_14)), (children_18 = [react.createElement("a", {
        className: "bfsbutton ",
        onClick: (_arg_1) => {
            onRechnungsnummerEnter(navigateTo);
        },
    }, "Anzeigen")], react.createElement("div", {
        className: "control",
    }, ...children_18))], react.createElement("div", {
        className: "field has-addons ",
    }, ...children_20))], react.createElement("div", {
        className: "column is-4-fullhd is-4-widescreen is-4-desktop is-6-tablet is-12-mobile",
    }, ...children_22))], react.createElement("div", {
        className: "card-body card-body-quickfinder columns",
    }, ...children_24))], react.createElement("div", {
        className: "flat-card is-auto",
    }, ...children_26))], react.createElement("div", {
        className: "is-relative",
    }, ...children_28))], react.createElement("div", {
        className: "column is-12 help-center",
    }, ...children_30))];
    return react.createElement("div", {
        className: "columns quickfinder-box",
    }, ...children_32);
}

export function quickfinderBoxDashboard(navigateTo, globalMsgdispatch, nummer) {
    let children_28, children_26, children_14, children, children_12, children_6, children_10, children_8, children_24, children_22, children_16, children_20;
    const children_30 = [(children_28 = [(children_26 = [(children_14 = [(children = [react.createElement("img", {
        className: "quickfinderImg",
        src: "dashboard/quickfinder_suche_96x96.svg",
    })], react.createElement("div", {
        className: "quickfinder-icon",
    }, ...children)), (children_12 = [(children_6 = [react.createElement("div", {
        className: "quickfinder-title",
    }, "Das Wichtigste auf einen Klick!"), react.createElement("p", {
        className: "sub quickfinder-description",
    }, "Hier finden Sie schnell Informationen zu einer beliebigen Rechnung.")], react.createElement("div", {}, ...children_6)), (children_10 = [(children_8 = ["Erklärvideo", react.createElement("img", {
        className: "play-icon",
        src: "dashboard/quickfinder_play_32x32.svg",
    })], react.createElement("a", {
        onClick: (_arg) => {
            globalMsgdispatch(new GlobalMsg(5, [Video_Quickfinder]));
        },
    }, ...children_8))], react.createElement("div", {
        className: "video-link",
    }, ...children_10))], react.createElement("div", {
        className: "quickfinder-text",
    }, ...children_12))], react.createElement("div", {
        className: "quickfinder-content",
    }, ...children_14)), (children_24 = [(children_22 = [(children_16 = [react.createElement("input", {
        id: "quickfinder-rechnungsnummer",
        className: "input",
        type: "text",
        defaultValue: nummer,
        onKeyDown: (e) => {
            if (e.key === "Enter") {
                onRechnungsnummerEnter(navigateTo);
            }
        },
        placeholder: "Rechnungsnr.",
    })], react.createElement("div", {
        className: "control quickfinder-rechnungsnummer",
    }, ...children_16)), (children_20 = [react.createElement("a", {
        className: "bfsbutton ",
        onClick: (_arg_1) => {
            onRechnungsnummerEnter(navigateTo);
        },
    }, "Anzeigen")], react.createElement("div", {
        className: "control",
    }, ...children_20))], react.createElement("div", {
        className: "field has-addons ",
    }, ...children_22))], react.createElement("div", {
        className: "searchbox",
    }, ...children_24))], react.createElement("div", {
        className: "card-body card-body-quickfinder",
    }, ...children_26))], react.createElement("div", {
        className: "flat-card is-auto",
    }, ...children_28))];
    return react.createElement("div", {
        className: "columns quickfinder-box quickfinder-dashboard",
    }, ...children_30);
}

export function box(body) {
    let children_4, children_2;
    const children_6 = [(children_4 = [(children_2 = [react.createElement("div", {
        className: "card-body",
    }, ...body)], react.createElement("div", {
        className: "flat-card profile-info-card is-auto",
    }, ...children_2))], react.createElement("div", {
        className: "column is-12",
    }, ...children_4))];
    return react.createElement("div", {
        className: "columns",
    }, ...children_6);
}

export function timelineStart(text) {
    const children_2 = [react.createElement("span", {
        className: "tag is-medium is-primary",
    }, text)];
    return react.createElement("header", {
        className: "timeline-header",
    }, ...children_2);
}

export function timelineIntermediate(text) {
    const children_2 = [react.createElement("span", {
        className: "tag is-primary",
    }, text)];
    return react.createElement("header", {
        className: "timeline-header",
    }, ...children_2);
}

export function ticketText(rechnungsnummer, information) {
    const arg_2 = asString(information.Datum);
    return toText(printf("Rechnung %s, Status \'%s\' vom %s"))(rechnungsnummer)(information.Typ)(arg_2);
}

export function downloadLink(dispatch, downloadType) {
    switch (downloadType.tag) {
        case 1:
            return Icons_DownloadLink(downloadType.fields[0], Http_downloadUrlDokumentAnfrage(downloadType.fields[1]));
        case 2:
            return Icons_DownloadLink(downloadType.fields[0], Http_downloadUrlSammelrechnung(downloadType.fields[1]));
        case 3:
            return Icons_DownloadLink2(downloadType.fields[0], (_arg) => {
                let message;
                dispatch(new Msg(5, [new GlobalMsg(3, [(message = "Sie möchten unseren Service für den Abruf Ihrer Dokumente nutzen? Diese Dienstleistung ermöglicht Ihnen den Zugriff und Download Ihrer eingereichten Belege. Buchen Sie diesen Service ganz einfach über die Einstellungen.", GlobalMessageBox_InfoWithTitle("Dokumentenabruf", message))])]));
            });
        default:
            return nothing;
    }
}

export const timelineItem = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_1("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\WebParts\\User\\QuickFinder\\View.fs") + "#L") + int32ToString(value_1(205))) + ";") + "System.Tuple`4[Microsoft.FSharp.Core.FSharpFunc`2[Quickfinder.Types.Msg,Microsoft.FSharp.Core.Unit],Microsoft.FSharp.Core.FSharpFunc`2[System.Object,Microsoft.FSharp.Core.Unit],System.String,Bfs.Web.Data.Service.Contracts.Kundenportal.Quickfinder.Information]", value_1("timelineItem"), (tupledArg) => {
    let children_8, props_6, matchValue_1, children_16, children_10, arg_2, children_14, children_12;
    const navigateTo = tupledArg[1];
    const information = tupledArg[3];
    const isExpanded = react.useState(false);
    const chevronClass = (isExpanded[0]) ? "upsidedown" : "";
    let expandableContent;
    const children_4 = toList(delay(() => {
        let children;
        return append((information.Hilfetext != null) ? singleton((children = [value_1(information.Hilfetext)], react.createElement("p", {}, ...children))) : empty(), delay(() => {
            let children_2;
            return singleton((children_2 = toList(delay(() => {
                let matchValue, id;
                return append((matchValue = information.TicketId, (matchValue != null) ? ((id = matchValue, singleton(Icons_TicketLink("Anzeigen", (_arg_1) => {
                    navigateTo(new Page_1(1, [id]));
                })))) : singleton(Icons_TicketErstellenLink((_arg) => {
                    navigateTo(new Page_1(3, [ticketText(tupledArg[2], information), information.RechnungId]));
                }))), delay(() => singleton(downloadLink(tupledArg[0], information.Download))));
            })), react.createElement("div", {}, ...children_2)));
        }));
    }));
    expandableContent = react.createElement("div", {
        className: "helptext ",
    }, ...children_4);
    const children_18 = [(children_8 = [(props_6 = [new HTMLAttr(65, [(matchValue_1 = information.Icon, (matchValue_1 != null) ? Quickfinder_QuickFinderIcon__ToCssIcon(matchValue_1) : information.LegacyIcon)])], react.createElement("div", keyValueList(props_6, 1)))], react.createElement("div", {
        className: "timeline-marker is-image is-32x32",
    }, ...children_8)), (children_16 = [(children_10 = [(arg_2 = asLongString(information.Datum), toText(printf("%s - %s"))(arg_2)(information.Typ))], react.createElement("p", {
        className: "date",
    }, ...children_10)), (children_14 = [information.Text, (children_12 = [linkicon(`fas fa-chevron-down ${chevronClass}`)], react.createElement("a", {}, ...children_12))], react.createElement("p", {
        className: "text",
        onClick: (_arg_2) => {
            isExpanded[1](!(isExpanded[0]));
        },
    }, ...children_14)), CollapsableElement([expandableContent, isExpanded[0]])], react.createElement("div", {
        className: "timeline-content",
    }, ...children_16))];
    return react.createElement("div", {
        className: "timeline-item",
    }, ...children_18);
}, undefined, undefined, "Of");

export function timelineItem2(dispatch, navigateTo, rechnungsnummer, prev, current) {
    return toArray(delay(() => append(((month(prev.Datum) !== month(current.Datum)) ? true : (year(prev.Datum) !== year(current.Datum))) ? singleton(timelineIntermediate(asMonatJahr(current.Datum))) : empty(), delay(() => singleton(timelineItem([dispatch, navigateTo, rechnungsnummer, current]))))));
}

export function timelineEnd(text) {
    const children_2 = [react.createElement("span", {
        className: "tag is-medium is-primary",
    }, text)];
    return react.createElement("div", {
        className: "timeline-header",
    }, ...children_2);
}

export function infoDisplay(dispatch, navigateTo, model, data) {
    const children_4 = toList(delay(() => {
        let children_2, children;
        return append(singleton((children_2 = [(children = toList(delay(() => append(model.AufsteigendSortieren ? singleton(linkicon("fas fa-sort-numeric-down")) : singleton(linkicon("fas fa-sort-numeric-up-alt")), delay(() => singleton("Sortierung ändern"))))), react.createElement("a", {
            onClick: (_arg) => {
                dispatch(new Msg(4, []));
            },
        }, ...children))], react.createElement("div", {
            className: "quicksort",
        }, ...children_2))), delay(() => {
            const data_1 = model.AufsteigendSortieren ? data : reverse(data);
            return concat(map((tupledArg) => timelineItem2(dispatch, navigateTo, model.Rechnungsnummer, tupledArg[0], tupledArg[1]), pairwise(append_1([Quickfinder_Information_get_NoInformation()], toArray_1(data_1)))));
        }));
    }));
    return react.createElement("div", {
        className: "timeline quickfinder",
    }, ...children_4);
}

export function rechnungZeile(dispatch, navigateTo, model, rechnung) {
    let children_2, children_8, children_12;
    const children_14 = [react.createElement("td", {}, `${rechnung.SendungsNr}`), (children_2 = [`${asString(rechnung.Rechnungsdatum)}`], react.createElement("td", {}, ...children_2)), react.createElement("td", {}, `${rechnung.Klient}`), react.createElement("td", {}, `${rechnung.Empfaenger}`), (children_8 = [asMoneySpan(rechnung.Betrag)], react.createElement("td", {
        className: "text-right",
    }, ...children_8)), (children_12 = [react.createElement("button", {
        className: "bfsbutton is-pulled-right is-small",
        onClick: (_arg) => {
            navigateTo(new Page(1, [model.Rechnungsnummer, rechnung.RechnungId]));
        },
    }, "Auswählen")], react.createElement("td", {}, ...children_12))];
    return react.createElement("tr", {}, ...children_14);
}

export function rechnungenSelectDisplay(dispatch, navigateTo, model, rechnungen) {
    let children, children_20, children_16, children_14, children_24, children_22, s_6;
    const rows = map_1((r) => rechnungZeile(dispatch, navigateTo, model, r), rechnungen);
    const children_26 = [(children = [`Die Rechnung ${model.Rechnungsnummer} wurde mehrfach in ${length(rechnungen)} verschiedenen Sendungen an uns übermittelt. Bitte wählen Sie die gesuchte Rechnung aus:`], react.createElement("div", {
        className: "infotext",
    }, ...children)), (children_20 = [(children_16 = [(children_14 = [react.createElement("th", {}, "SendungsNr"), react.createElement("th", {}, "Rechnungsdatum"), react.createElement("th", {}, "Klient"), react.createElement("th", {}, "Empfänger"), react.createElement("th", {}, "Betrag"), react.createElement("td", {})], react.createElement("tr", {}, ...children_14))], react.createElement("thead", {}, ...children_16)), react.createElement("tbody", {}, ...rows)], react.createElement("table", {
        className: "table table-striped responsive-table is-hidden-touch is-bfscolored",
    }, ...children_20)), (children_24 = [(children_22 = [(s_6 = "Bitte beachten Sie, dass eine mehrfache Einreichung normalerweise keine mehrfache Auszahlung nach sich zieht.", s_6)], react.createElement("p", {}, ...children_22))], react.createElement("div", {
        className: "helptext",
    }, ...children_24))];
    return react.createElement("div", {
        className: "rechnung-select",
    }, ...children_26);
}

export function displayQuickfinderResponse(dispatch, navigateTo, model, response) {
    if (response.tag === 1) {
        const rechnungenSelect = response.fields[0];
        if (isEmpty(rechnungenSelect)) {
            return toText(printf("Die Rechnungsnummer %s konnten wir leider nicht finden. Bitte überprüfen Sie Ihre Eingabe."))(model.Rechnungsnummer);
        }
        else {
            return rechnungenSelectDisplay(dispatch, (arg_2) => {
                navigateTo(arg_2);
            }, model, rechnungenSelect);
        }
    }
    else {
        const i = response.fields[0];
        if (isEmpty(i)) {
            return toText(printf("Die Rechnungsnummer %s konnten wir leider nicht finden. Bitte überprüfen Sie Ihre Eingabe."))(model.Rechnungsnummer);
        }
        else {
            return infoDisplay(dispatch, navigateTo, model, i);
        }
    }
}

export function view(model, dispatch, navigateTo) {
    return Array.from(delay(() => append(singleton(quickfinderBox(navigateTo, (arg) => {
        dispatch(new Msg(5, [arg]));
    }, model.Rechnungsnummer)), delay(() => {
        const matchValue = model.Rechnungsnummer;
        const matchValue_1 = model.QuickfinderResponse;
        let matchResult;
        if (matchValue === defaultOf()) {
            matchResult = 0;
        }
        else if (matchValue === "") {
            matchResult = 0;
        }
        else {
            switch (matchValue_1.tag) {
                case 1: {
                    matchResult = 1;
                    break;
                }
                case 2: {
                    matchResult = 2;
                    break;
                }
                case 3: {
                    matchResult = 3;
                    break;
                }
                default:
                    matchResult = 0;
            }
        }
        switch (matchResult) {
            case 0:
                return singleton(nothing);
            case 1:
                return singleton(box([spinner]));
            case 2:
                return singleton(box([errorMsg(matchValue_1.fields[0])]));
            default:
                return singleton(box([displayQuickfinderResponse(dispatch, navigateTo, model, matchValue_1.fields[0])]));
        }
    }))));
}

//# sourceMappingURL=View.fs.js.map
